import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { UserUrl } from '../../shared/urls/user.url';
import { PatientUrl } from '../../shared/urls/patient.url';
import { CompanyAccountUrl } from '../../shared/urls/company-account.url';

@Injectable()
export class RegisterService {
    constructor(public baseService: BaseService) {

    }

    getCountryList() {
        return this.baseService.getData(UserUrl.GET_USER_COUNTRY_INIT);
    }

    getInit() {
        return this.baseService.getData(PatientUrl.PATIENT_INIT);
    }

    getParty() {
        return this.baseService.getData(CompanyAccountUrl.GET_COMPANY_ACCOUNT_INIT);
    }

    getTypeParty(): any[] {
        return [
            {
                id: 0,
                name: 'Individual'
            },
            {
                id: 1,
                name: 'Group'
            }
        ];
    }

    getSexData(): any[] {
        return [
            {
                id: 0,
                name: 'Male'
            },
            {
                id: 1,
                name: 'Female'
            }
        ];
    }

    addAccount(param) {
        return this.baseService.postData(PatientUrl.PATIENT_ADD, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/register/register.service.ts